<template>
  <v-layout row wrap>
    <v-btn
      v-for="(text, index) in items"
      :key="index"
      :class="{ active: current == text }"
      class="jns-button blue-button flex mb-4"
      :value="text"
      @click="$emit('change-tab', $event)"
      >
      {{ text }}
      <v-icon v-if="current == text" class>check_circle_alt</v-icon>
    </v-btn>
  </v-layout>
</template>

<script type="js">
export default {
  name: "DocumentTabs",
  props: {
    items: { type: Array },
    current: { type: String },
  }
};
</script>



// WEBPACK FOOTER //
// ./src/components/DocumentTabs.vue